export const rupees = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export const COMMISSION_STATUS = {
    pending: { label: "Pending", color: "warning" },
    credited: { label: "Credited", color: "success" },
    reversed: { label: "Reversed", color: "error" },
    cancelled: { label: "Cancelled", color: "default" },
};

export const WALLET_TX = {
    credit: { label: "Reward credited", color: "success" },
    reversal: { label: "Reward reversed", color: "error" },
    adjustment: { label: "Manual adjustment", color: "info" },
};

const csvCell = (value) => {
    const text = value === null || value === undefined ? "" : String(value);
    return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

// Download rows as a CSV file. columns: [[header, (row) => value], ...]
export const downloadCsv = (filename, columns, rows) => {
    const lines = [columns.map(([h]) => csvCell(h)).join(",")];
    for (const row of rows) lines.push(columns.map(([, get]) => csvCell(get(row))).join(","));
    const blob = new Blob(["﻿" + lines.join("\n")], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
};

export const csvDate = (value) => (value ? new Date(value).toLocaleString("en-IN") : "");
